import { forwardRef } from 'react';

import { Link as LinkComponent, type LinkProps as LinkPropsComponent } from '@braskai/ui-kit';
import { Link, type LinkProps } from 'react-router-dom';

export type RouterLinkProps = LinkProps & Omit<LinkPropsComponent, 'component'>;

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
  <LinkComponent component={Link} ref={ref} {...props} />
));
